module.exports = __webpack_public_path__ + "static/jina-f449a4ccb5878d24d7471f6669e97002.jpg";